import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import PricingTable from "../TableComponents/PricingTable";

/**
 * ATF template for brand pages: intro text (collapsible) + price table + note below table.
 * - content: string or { text: string[] }
 * - tableData: { type: "pricing", heading, columns, data }
 * - note: string shown below the table
 */
const AtfContentSectionBrand = ({
  content,
  tableData = null,
  note = "",
  collapsedHeight = { xs: "96px", md: "51px" },
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderContent = () => {
    if (typeof content === "string") {
      return (
        <Typography
          variant="body1"
          sx={{
            marginBottom: "10px",
            fontSize: { xs: "12px", md: "16px" },
            fontWeight: 400,
            color: "#000",
            lineHeight: 1.6,
          }}
        >
          {content}
        </Typography>
      );
    }

    if (content?.text && Array.isArray(content.text)) {
      return content.text.map((text, index) => (
        <React.Fragment key={index}>
          <Typography
            variant="body1"
            sx={{
              marginBottom: index < content.text.length - 1 ? "10px" : "0",
              fontSize: { xs: "12px", md: "16px" },
              fontWeight: 400,
              color: "#000",
              lineHeight: 1.6,
            }}
          >
            {text}
          </Typography>
          {index < content.text.length - 1 && <br />}
        </React.Fragment>
      ));
    }

    return null;
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "84%" },
        margin: "20px auto",
        padding: { xs: "0 12px", md: "0" },
      }}
    >
      <Box
        sx={{
          maxHeight: isExpanded ? "none" : collapsedHeight,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {renderContent()}

        {tableData && (
          <Box
            sx={{
              marginTop: "20px",
              display: isExpanded ? "block" : "none",
            }}
          >
            {tableData.type === "pricing" && (
              <>
                <PricingTable
                  heading={tableData.heading}
                  columns={tableData.columns}
                  data={tableData.data}
                  inline={true}
                />
                {note && (
                  <div className="mt-8 mb-8">
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: "12px", md: "14px" },
                        fontWeight: 400,
                        color: "#000",
                        lineHeight: 1.6,
                        fontStyle: "italic",
                      }}
                    >
                      {note}
                    </Typography>
                  </div>
                )}
              </>
            )}
          </Box>
        )}
      </Box>

      <Typography
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{
          marginTop: "10px",
          color: "#024670",
          fontSize: { xs: "12px", md: "14px" },
          fontWeight: "bold",
          cursor: "pointer",
          display: "inline-block",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </Typography>
    </Box>
  );
};

export default AtfContentSectionBrand;
